import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import Axios from 'axios';
import { Helmet } from 'react-helmet-async';

import { SnackbarContext } from './userContext';
import { Loading } from './Loading';
import { Recommended } from './Recommended';
import { SearchFilterBar } from './SearchFilterBar';

import { PageContainer } from '../theme/primitives';

const key = 'dqweqwe123y97qhduiasd$@^!*#&bjasdja&^&@!#';

const I = {
  ArrowRight: ({ className }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden>
      <path d="M5 12h14M13 5l7 7-7 7" />
    </svg>
  ),
  ShieldCheck: ({ className }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden>
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      <path d="m9 12 2 2 4-4" />
    </svg>
  ),
  Phone: ({ className }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden>
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.37 1.9.72 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.35 1.85.59 2.81.72a2 2 0 0 1 1.72 2z" />
    </svg>
  ),
  Globe: ({ className }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden>
      <circle cx="12" cy="12" r="10" />
      <path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
    </svg>
  ),
  Trend: ({ className }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden>
      <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
      <polyline points="17 6 23 6 23 12" />
    </svg>
  ),
};

export const Home = () => {
  const history = useNavigate();
  const { setSnack } = useContext(SnackbarContext);

  const [loading, setLoading] = useState(true);
  const [, setSlides] = useState([]);
  const [cats, setCats] = useState([]);
  const [subcats, setSubcats] = useState([]);
  const [rec, setRec] = useState([]);
  const [, setFea] = useState([]);
  const [metadata, setMetadata] = useState(null);

  const [loc, setLoc] = useState(localStorage.getItem('loc') || '');
  const [cat, setCat] = useState('0');
  const [subCat, setSubcat] = useState('0');
  const [search, setSearch] = useState('');
  const [error, setError] = useState(0);

  // Pick up the location once App.js's getLocation finishes (it dispatches
  // 'esay:locchange' after the user accepts/denies the geolocation prompt).
  useEffect(() => {
    const sync = () => setLoc(localStorage.getItem('loc') || '');
    window.addEventListener('esay:locchange', sync);
    return () => window.removeEventListener('esay:locchange', sync);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);

    Axios.post('/new_apis/getsinglemetadata', { type: 'home' }, { headers: { key } }).then((res) => {
      if (res.data.status) setMetadata(res.data.metadata[0]);
      else setMetadata({
        seo_title: 'Home - ESAY | Contacts and Info in the World of Construction',
        seo_desc: 'Get all the information and contacts of various types of contractors, consultants, machinery/material suppliers, engineers, and workforce in the construction sector',
        seo_keywords: 'best contractors, schedule of rates, construction engineers near me',
      });
    });

    Axios.get('/new_apis/get-home-data', { headers: { key } }).then((res) => {
      setSlides(res.data.slides || []);
      setCats(res.data.cats || []);
      setSubcats(res.data.subcats || []);
      setFea(res.data.featured || []);
      setRec(res.data.recommended || []);
      setLoading(false);
    });
  }, []);

  const subcatOptions = subcats.filter((sc) => sc.category_ids === cat);

  const handleSearch = (e) => {
    if (e) e.preventDefault();
    setError(0);
    if (!loc) {
      setError(1);
      setSnack({ message: 'Please enter your location.', type: 'error', open: true });
      return;
    }
    if (cat === '0') {
      setError(2);
      setSnack({ message: 'Please select a category.', type: 'error', open: true });
      return;
    }
    history(`/searchresults/${loc}/${cat}/${subCat}/${search}`);
  };

  if (loading) return <Loading />;

  return (
    <>
      {metadata && (
        <Helmet>
          <title>{metadata.seo_title}</title>
          <meta name="description" content={metadata.seo_desc} />
          <meta name="keywords" content={metadata.seo_keywords} />
        </Helmet>
      )}

      {/* ═══════════════════ Hero ═══════════════════ */}
      <section className="relative pt-12 pb-9 md:pt-14 md:pb-10 lg:pt-16 lg:pb-12">
        {/* Bg layers */}
        <div aria-hidden className="pointer-events-none absolute inset-0 -z-10 overflow-hidden">
          {/* amber radial glows */}
          <div
            className="absolute inset-0"
            style={{
              background: `
                radial-gradient(1200px 600px at 12% -10%, rgba(251,191,36,0.18), transparent 55%),
                radial-gradient(900px 520px at 88% 110%, rgba(251,191,36,0.12), transparent 55%),
                linear-gradient(180deg, #0A0A0B 0%, #121214 100%)
              `,
            }}
          />
          {/* grid */}
          <div
            className="absolute inset-0 opacity-50"
            style={{
              backgroundImage:
                'linear-gradient(#26262B 1px, transparent 1px), linear-gradient(90deg, #26262B 1px, transparent 1px)',
              backgroundSize: '64px 64px',
              maskImage: 'radial-gradient(ellipse 70% 60% at 50% 45%, #000 0%, transparent 85%)',
              WebkitMaskImage: 'radial-gradient(ellipse 70% 60% at 50% 45%, #000 0%, transparent 85%)',
            }}
          />
          {/* noise */}
          <div
            className="absolute inset-0 opacity-[0.04] mix-blend-overlay"
            style={{
              backgroundImage:
                "url(\"data:image/svg+xml;utf8,<svg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='2' stitchTiles='stitch'/></filter><rect width='100%25' height='100%25' filter='url(%23n)'/></svg>\")",
            }}
          />
        </div>

        <PageContainer maxWidth="lg">
          <div className="relative mx-auto text-center max-w-[860px]">
            {/* Kicker pill */}
            <div className="inline-flex items-center gap-2 rounded-full border border-amber/30 bg-amber/10 px-3.5 py-1.5 mb-5">
              <span aria-hidden className="relative flex h-1.5 w-1.5">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-amber opacity-60" />
                <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-amber" style={{ boxShadow: '0 0 12px rgba(251,191,36,0.8)' }} />
              </span>
              <span className="text-[10.5px] font-bold uppercase tracking-[0.18em] text-amber">
                Construction · Engineering · Infrastructure
              </span>
            </div>

            {/* Title */}
            <h1
              className="font-bold text-fg-primary leading-[1.05] tracking-[-0.035em] m-0"
              style={{ fontSize: 'clamp(2rem, 5.5vw, 3.25rem)' }}
            >
              Engineering sources,
              <br />
              <span
                className="inline-block"
                style={{
                  background: 'linear-gradient(135deg, #FCD34D 0%, #FBBF24 50%, #D97706 100%)',
                  WebkitBackgroundClip: 'text',
                  backgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                }}
              >
                around you.
              </span>
            </h1>

            {/* Lead */}
            <p className="mx-auto mt-6 max-w-[620px] text-[14px] sm:text-[15.5px] leading-[1.65] text-fg-secondary">
              Discover verified contractors, consultants, machinery suppliers, engineers and workforce - the construction industry's trusted directory, built for professionals.
            </p>
          </div>

          {/* Search bar */}
          <SearchFilterBar
            className="mt-8 sm:mt-10"
            loc={loc} setLoc={setLoc}
            cat={cat} setCat={setCat}
            subCat={subCat} setSubcat={setSubcat}
            search={search} setSearch={setSearch}
            cats={cats}
            subcatOptions={subcatOptions}
            error={error}
            onSubmit={handleSearch}
            buttonLabel="Search"
          />

          {/* Trust strip */}
          <div className="relative mx-auto max-w-[860px]">
            <div className="mt-6 sm:mt-8 flex flex-wrap justify-center gap-x-6 gap-y-2">
              <span className="inline-flex items-center gap-1.5 text-[12.5px] font-semibold text-amber">
                <I.ShieldCheck className="h-4 w-4" />
                Verified partners
              </span>
              <span className="hidden sm:inline-flex items-center gap-1.5 text-[12.5px] font-semibold text-amber">
                <I.Phone className="h-4 w-4" />
                Direct contact, zero middlemen
              </span>
              <span className="inline-flex items-center gap-1.5 text-[12.5px] font-semibold text-amber">
                <I.Globe className="h-4 w-4" />
                Pan-India coverage
              </span>
            </div>
          </div>
        </PageContainer>
      </section>

      {/* ═══════════════════ Value props ═══════════════════ */}
      <PageContainer maxWidth="lg">
        <section className="py-6 sm:py-8 md:py-10">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
            {[
              { Icon: I.ShieldCheck, title: 'Verified, source-first', body: 'Every listing is vetted. You reach businesses that want to be found - not middlemen, not aggregators.' },
              { Icon: I.Phone,       title: 'Direct, one click',     body: 'Call, message, or shortlist suppliers in a tap. No forms to fill, no quotes to chase, no friction in between.' },
              { Icon: I.Trend,       title: 'Built for the industry',body: 'Trends, engineering info, conversions, and careers - the reference tools professionals actually use, in one place.' },
            ].map(({ Icon, title, body }) => (
              <div
                key={title}
                className="
                  group relative overflow-hidden h-full
                  rounded-2xl border border-border-subtle bg-surface-paper
                  p-5 sm:p-6
                  transition-[border-color,transform,box-shadow] duration-200 ease-out-soft
                  hover:border-amber/45 hover:-translate-y-1 hover:shadow-card-hover
                "
              >
                <span aria-hidden className="pointer-events-none absolute inset-x-6 top-0 h-px bg-gradient-to-r from-transparent via-amber/40 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
                <div className="
                  flex h-11 w-11 items-center justify-center rounded-xl mb-3
                  bg-gradient-to-br from-amber/30 to-amber/10 border border-amber/30 text-amber
                  transition-[border-color,box-shadow] duration-300
                  group-hover:border-amber/60
                  group-hover:shadow-[0_0_0_3px_rgba(251,191,36,0.15)]
                ">
                  <Icon className="h-5 w-5" />
                </div>
                <h3 className="text-[15px] font-bold tracking-[-0.01em] text-fg-primary transition-colors duration-200 group-hover:text-amber">
                  {title}
                </h3>
                <div aria-hidden className="mt-1.5 h-[2px] w-8 rounded-full bg-gradient-to-r from-amber to-amber/0" />
                <p className="mt-2 text-[13px] leading-[1.6] text-fg-secondary">
                  {body}
                </p>
              </div>
            ))}
          </div>
        </section>
      </PageContainer>

      {/* ═══════════════════ Categories ═══════════════════ */}
      {cats.length > 0 && (
        <PageContainer maxWidth="lg">
          <section className="py-8 md:py-10">
            <div className="mb-6 md:mb-8 text-center">
              <div className="mb-1.5 inline-flex items-center gap-1.5">
                <span aria-hidden className="relative flex h-1.5 w-1.5">
                  <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-amber opacity-60" />
                  <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-amber" />
                </span>
                <span className="text-[10.5px] font-bold uppercase tracking-[0.18em] text-amber">Explore</span>
              </div>
              <h2 className="text-[22px] md:text-[28px] font-bold leading-[1.15] tracking-[-0.025em] text-fg-primary">
                Browse by specialty
              </h2>
              <div aria-hidden className="mx-auto mt-2 h-[2px] w-12 rounded-full bg-gradient-to-r from-transparent via-amber to-transparent" />
              <p className="mx-auto mt-2 max-w-[560px] text-[13px] sm:text-[14px] leading-[1.6] text-fg-secondary">
                Professionals, suppliers and services organized by the work they do.
              </p>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
              {cats.map((item) => (
                <RouterLink
                  key={item.category_id}
                  to={`/searchresults/${loc}/${item.category_id}`}
                  title={item.category_name}
                  className="
                    group relative block aspect-[5/4] overflow-hidden rounded-xl
                    border border-border-subtle bg-surface-paper
                    transition-[transform,border-color,box-shadow] duration-300 ease-out-soft
                    hover:-translate-y-1 hover:border-amber hover:shadow-amber-glow-strong
                  "
                >
                  <img
                    src={item.category_image}
                    alt=""
                    loading="lazy"
                    className="absolute inset-0 h-full w-full object-cover transition-transform duration-[900ms] ease-out-soft group-hover:scale-[1.08]"
                  />
                  <div
                    aria-hidden
                    className="absolute inset-0 bg-gradient-to-t from-black/95 via-black/40 to-transparent transition-opacity duration-500 ease-out-soft group-hover:opacity-75"
                  />
                  <div
                    aria-hidden
                    className="pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-500 ease-out-soft group-hover:opacity-100"
                    style={{
                      background:
                        'radial-gradient(ellipse 80% 50% at 50% 100%, rgba(251,191,36,0.22), transparent 70%)',
                    }}
                  />
                  <div className="absolute inset-x-4 bottom-4">
                    <h3 className="text-[14px] md:text-[15px] font-semibold leading-tight tracking-[-0.01em] text-white line-clamp-2 transition-transform duration-300 ease-out-soft group-hover:-translate-y-0.5">
                      {item.category_name}
                    </h3>
                    <div className="mt-2 flex items-center gap-2">
                      <span
                        aria-hidden
                        className="block h-[2px] w-5 bg-amber transition-[width,background-color] duration-500 ease-out-soft group-hover:w-10 group-hover:bg-amber-light"
                      />
                      <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-amber opacity-0 -translate-x-1 transition-[opacity,transform] duration-300 ease-out-soft group-hover:opacity-100 group-hover:translate-x-0">
                        Explore
                      </span>
                    </div>
                  </div>
                </RouterLink>
              ))}
            </div>
          </section>
        </PageContainer>
      )}

      {/* ═══════════════════ Recommended ═══════════════════ */}
      {rec.length > 0 && (
        <PageContainer maxWidth="lg">
          <Recommended recs={rec} />
        </PageContainer>
      )}

      {/* ═══════════════════ CTA Band ═══════════════════ */}
      <PageContainer maxWidth="lg">
        <section
          className="
            relative isolate overflow-hidden
            mt-6 mb-3
            rounded-[20px] border border-amber/30
            px-5 py-10 sm:px-8 sm:py-14
            text-center
          "
          style={{
            background: `
              radial-gradient(800px 300px at 20% 50%, rgba(251,191,36,0.22), transparent 60%),
              radial-gradient(600px 300px at 80% 50%, rgba(251,191,36,0.14), transparent 60%),
              linear-gradient(180deg, #1A1A1D, #121214)
            `,
          }}
        >
          <div
            aria-hidden
            className="absolute inset-0 -z-10 opacity-35"
            style={{
              backgroundImage:
                'linear-gradient(#26262B 1px, transparent 1px), linear-gradient(90deg, #26262B 1px, transparent 1px)',
              backgroundSize: '40px 40px',
              maskImage: 'radial-gradient(ellipse at center, #000, transparent 75%)',
              WebkitMaskImage: 'radial-gradient(ellipse at center, #000, transparent 75%)',
            }}
          />
          <span aria-hidden className="pointer-events-none absolute inset-x-12 top-0 h-px bg-gradient-to-r from-transparent via-amber/70 to-transparent" />

          <div className="mb-3 inline-flex items-center gap-2 rounded-full border border-amber/40 bg-amber/15 px-3 py-1">
            <I.Trend className="h-3.5 w-3.5 text-amber" />
            <span className="text-[10.5px] font-bold uppercase tracking-[0.18em] text-amber">Grow your business</span>
          </div>
          <h2
            className="font-bold tracking-[-0.022em] text-fg-primary leading-[1.1] m-0"
            style={{ fontSize: 'clamp(1.5rem, 3vw, 2rem)' }}
          >
            List your business on ESAY.
          </h2>
          <div aria-hidden className="mx-auto mt-3 h-[2px] w-12 rounded-full bg-gradient-to-r from-transparent via-amber to-transparent" />
          <p className="mx-auto mt-3 max-w-[520px] text-[13px] sm:text-[14px] leading-[1.6] text-fg-secondary">
            Reach construction-industry buyers actively searching for what you offer. Create your profile in minutes - no setup cost.
          </p>

          <div className="mt-5 inline-flex flex-wrap items-center justify-center gap-2">
            <RouterLink
              to="/signup"
              className="
                group inline-flex h-12 items-center justify-center gap-1.5 rounded-lg px-6
                text-[12.5px] font-bold uppercase tracking-[0.1em]
                bg-amber text-ink
                transition-[background-color,box-shadow,transform] duration-200 ease-out-soft
                hover:bg-amber-light
                hover:shadow-[0_0_0_3px_rgba(251,191,36,0.32),0_10px_28px_-8px_rgba(251,191,36,0.6)]
                active:scale-[0.98]
              "
            >
              <span>Create your listing</span>
              <I.ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5" />
            </RouterLink>
            <RouterLink
              to="/about"
              className="
                inline-flex h-12 items-center justify-center gap-1.5 rounded-lg px-6
                text-[12.5px] font-bold uppercase tracking-[0.08em]
                border border-amber/40 text-amber
                transition-[background-color,border-color] duration-200
                hover:bg-amber/10 hover:border-amber/70
              "
            >
              Learn more
            </RouterLink>
          </div>
        </section>
      </PageContainer>
    </>
  );
};
